import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationContainerComponent } from './authentication.container.component';
import { ArcWidgetsModule } from '@arc/arc-shared-frontend';
import { RouterModule } from '@angular/router';
import { AuthenticationRouting } from './authentication.routes';
import { LoginContainerComponent } from './login/login.container.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordContainerComponent } from './forgotpassword/forgotpassword.container.component';
import { ForgotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { CodeVerificationComponent } from './codeverification/codeverification.component';
import { CodeVerificationContainerComponent } from './codeverification/codeverification.container.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { PasswordresetContainerComponent } from './passwordreset/passwordreset.container.component';
import { ForceResetPasswordContainerComponent } from './forceresetpassword/forceresetpassword.container.component';
import { JPMorganEConsentComponent } from './jpmorgan-econsent/jpmorgan-econsent.component';
@NgModule({
  declarations: [
    AuthenticationContainerComponent,
    LoginContainerComponent,
    LoginComponent,
    ForgotPasswordContainerComponent,
    ForgotPasswordComponent,
    CodeVerificationContainerComponent,
    CodeVerificationComponent,
    PasswordresetContainerComponent,
    PasswordresetComponent,
    ForceResetPasswordContainerComponent,
    JPMorganEConsentComponent
  ],
  imports: [CommonModule, ArcWidgetsModule, AuthenticationRouting],
  exports: [RouterModule]
})
export class AuthenticationModule {}
